import { ShoppedServicesSchema } from "@redotech/redo-fulfillment-rate-common/shopped-services";
import * as z from "zod";

export const getFulfillmentGroupShoppedServices = {
  name: "getFulfillmentGroupShoppedServices" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: ShoppedServicesSchema,
};
